export const QUICK_REPLIES = [
  'Is this still available?',
  "What's the lowest price you can do?",
  'Can you deliver?',
  'Where are you located?',
  'When can I see it?',
  'Is the price negotiable?',
];
